import { createSelector } from 'reselect';

import { getContentType } from '../../../selectors/element';

import CreativeContent from '../../../model/creative-content/content/CreativeContent';

import { isEmpty as isEmptyArray } from '../../../util/array';
import { isEmpty as isEmptyObject } from '../../../util/object';

export const getCreativeFieldsByContentType = (state) =>
  state.creativeContent.creativeFieldsByContentType;
export const getAllCreativeFieldsById = (state) =>
  state.creativeContent.creativeFieldsById;
export const getAllContentSelectorsById = (state) =>
  state.creativeContent.contentSelectorsById;
export const getScrapedCreativeContent = (state) =>
  state.creativeContent.scrapedCreativeContent;
export const getSourceContent = (state) => state.creativeContent.sourceContent;
export const getSourceContentUrl = (state) =>
  state.creativeContent.sourceContentUrl;
export const isLoadingCreativeFields = (state) =>
  state.creativeContent.isLoadingCreativeFields;

export const getAllCreativeFieldIds = createSelector(
  [getAllCreativeFieldsById],
  (allCreativeFieldsById) => Object.keys(allCreativeFieldsById),
);

export const hasCreativeFieldWithCreativeContent = createSelector(
  [getAllCreativeFieldsById, getAllCreativeFieldIds],
  (allCreativeFieldsById, allCreativeFieldIds) => {
    return allCreativeFieldIds.some((allCreativeFieldId) =>
      CreativeContent.isCreativeContent(
        allCreativeFieldsById[allCreativeFieldId].creativeContent,
      ),
    );
  },
);

export const getCreativeFieldsForElement = createSelector(
  [getContentType, getCreativeFieldsByContentType, getAllCreativeFieldsById],
  (contentType, creativeFieldsByContentType, allCreativeFieldsById) => {
    if (
      isEmptyObject(creativeFieldsByContentType) ||
      isEmptyArray(creativeFieldsByContentType[contentType])
    ) {
      return undefined;
    }

    return creativeFieldsByContentType[contentType].map(
      (creativeFieldId) => allCreativeFieldsById[creativeFieldId],
    );
  },
);

export const getScrapedCreativeContentByHashId = createSelector(
  [getScrapedCreativeContent, (state, hashId) => hashId],
  (creativeContent, hashId) => {
    return !isEmptyObject(creativeContent)
      ? creativeContent[hashId]
      : undefined;
  },
);
